module.exports = __webpack_public_path__ + "static/media/sonic.433a8300.jpg";